import { useNavigation } from "@react-navigation/core";
import { Box, Button, FlatList, HStack, Text, VStack } from "native-base";
import React from "react";

type Props = {};

export function DuringTreatment({}: Props) {
  const navigation = useNavigation();

  const data = [
    {
      id: "1",
      title: "Acesso a medicamentos",
      description: "Acesso a medicamentos de alto custo",
      infoId: 4,
    },
    {
      id: "2",
      title: "Tratamento fora do domicílio",
      description: "Ajuda de custo para deslocamentos acima de 50 km",
      infoId: 6,
    },
    {
      id: "3",
      title: "Auxílio doença",
      description:
        "Trabalhadoras CLT que necessitem faltar ao trabalho por mais de 15 dias em virtude da doença.",
      infoId: 7,
    },
    {
      id: "4",
      title: "Aposentadoria por invalidez",
      description: "Quando a incapacidade para o trabalho é definitiva.",
      infoId: 11,
    },
    {
      id: "5",
      title: "BCP-LOAS",
      description:
        "Benefício de Prestação Continuada da Lei Orgânica da Assistência Social",
      infoId: 17,
    },
    {
      id: "6",
      title: "Isenção de imposto de renda",
      description: "Isenção de imposto de renda",
      infoId: 20,
    },
    {
      id: "7",
      title: "Isenção de imposto de veículo",
      description: "Isenção de impostos na aquisição de veículos",
      infoId: 23,
    },
    {
      id: "8",
      title: "Isenção de IPTU",
      description: "Isenção de IPTU",
      infoId: 30,
    },
    {
      id: "9",
      title: "Quitação de financiamento de imóvel",
      description: "Quitação de financiamento de imóvel",
      infoId: 31,
    },
    {
      id: "10",
      title: "Saque do FGTS",
      description: "Saque do FGTS",
      infoId: 33,
    },
    {
      id: "11",
      title: "Saque do PIS/PASEP",
      description: "Saque do PIS/PASEP",
      infoId: 35,
    },
    {
      id: "12",
      title: "Passe livre interestadual",
      description: "Passe livre interestadual",
      infoId: 37,
    },
    {
      id: "13",
      title: "Cirurgia reparadora",
      description: "Cirurgia para reconstrução da mama",
      infoId: 39,
    },
    {
      id: "14",
      title: "Prioridade para receber créditos",
      description:
        "Prioridade para receber créditos decorrentes de ações contra o estado por meio de precatórios judiciais",
      infoId: 41,
    },
  ];

  const handleClickMoreInfo = (infoId: number) => {
    navigation.navigate("InfoPage", { infoId });
  };

  return (
    <Box flex={1} bgColor="white" p="8">
      <VStack space={8} w="100%">
        <Text
          fontSize="2xl"
          fontWeight="bold"
          textAlign="center"
          color="#f4545c"
        >
          Durante o Tratamento você tem acesso aos seguintes direitos
        </Text>
        <FlatList
          w="100%"
          h="80%"
          data={data}
          renderItem={({ item }) => (
            <Box pl={["0", "4"]} pr={["0", "5"]} pb="8">
              <HStack
                space={[2, 3]}
                justifyContent="space-between"
                alignItems="center"
              >
                <VStack space={2}>
                  <Text color="#e8af9d" bold fontSize="md">
                    {item.title}
                  </Text>
                  <Text
                    color="coolGray.600"
                    _dark={{
                      color: "warmGray.200",
                    }}
                    fontSize="sm"
                    maxW="80%"
                  >
                    {item.description}
                  </Text>
                </VStack>
                <Button
                  bg="#f4545c"
                  h="16"
                  onPress={() => handleClickMoreInfo(item.infoId)}
                >
                  + Info
                </Button>
              </HStack>
            </Box>
          )}
          keyExtractor={(item) => item.id}
        />
      </VStack>
    </Box>
  );
}
